"use client";

import { NKCurrencyInput } from "@/components/nk/currency-input";

/* ──────────────────────────────────────────────────────────────────────────
 * BorrowedInput — currency field for the loan principal.
 *
 * Thin wrapper around NKCurrencyInput that clamps the propagated value to
 * >= $1. The simulator divides `borrowed / firstPrice` to compute units;
 * a zero would explode that. The user can still display empty while typing,
 * but we don't update the simulator with values below $1.
 * ────────────────────────────────────────────────────────────────────────── */

export interface BorrowedInputProps {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}

export function BorrowedInput({ value, onChange, disabled }: BorrowedInputProps) {
  return (
    <NKCurrencyInput
      value={value}
      onChange={(v) => {
        if (v === undefined || v < 1) return;
        onChange(v);
      }}
      currency="CAD"
      disabled={disabled}
      className="font-display h-9 text-lg font-medium"
    />
  );
}
